import { Alert, AlertType } from '@api';
import { createDate } from '@tsp-ui/core';
import { rest } from 'msw';

import { getMockUrl } from '../../mocks/getMockUrl';


let alertID = 100;

export function getActiveAlertsForCustomer(customerId: string): Alert[] {
    return alertsBase
        .filter(alert => alert.isActive)
        .map(alert => ({
            ...alert,
            customerId
        }));
}

export const mocks = [
    rest.get(getMockUrl('/client/:clientID/customer/:customerID/alerts'), (req, res, ctx) => {
        const { customerID } = req.params;

        const activeAlerts = getActiveAlertsForCustomer(customerID as string);

        return res(
            ctx.status(200),
            ctx.json(activeAlerts)
        );
    })
];

export const alertsBase: Alert[] = [
    {
        id: `${alertID++}`,
        customerId: '1',
        date: createDate(-0.007).toISOString(),
        isActive: true,
        alertType: AlertType.LICENSE_EXPIRATION
    },
    {
        id: `${alertID++}`,
        customerId: '1',
        date: createDate(-0.5).toISOString(),
        isActive: false,
        alertType: AlertType.COMPENSATION_FEE
    },
    {
        id: `${alertID++}`,
        customerId: '2',
        date: createDate(-0.021).toISOString(),
        isActive: true,
        alertType: AlertType.LOCK_AVAILABILITY
    },
    {
        id: `${alertID++}`,
        customerId: '1',
        date: createDate(-0.042).toISOString(),
        isActive: true,
        alertType: AlertType.ELIGIBILITY
    },
    {
        id: `${alertID++}`,
        customerId: '1',
        date: createDate(-0.125).toISOString(),
        isActive: true,
        alertType: AlertType.ELIGIBLE_PRODUCT
    },
    {
        id: `${alertID++}`,
        customerId: '1',
        date: createDate(-0.25).toISOString(),
        isActive: true,
        alertType: AlertType.LIMIT
    },
    {
        id: `${alertID++}`,
        customerId: '3',
        date: createDate(-0.75).toISOString(),
        isActive: false,
        alertType: AlertType.ELIGIBILITY
    },
    {
        id: `${alertID++}`,
        customerId: '3',
        date: createDate(-1).toISOString(),
        isActive: false,
        alertType: AlertType.ELIGIBLE_PRODUCT
    },
    {
        id: `${alertID++}`,
        customerId: '3',
        date: createDate(-1.5).toISOString(),
        isActive: false,
        alertType: AlertType.LIMIT
    },
    {
        id: `${alertID++}`,
        customerId: '2',
        date: createDate(-1.75).toISOString(),
        isActive: true,
        alertType: AlertType.ELIGIBILITY
    },
    {
        id: `${alertID++}`,
        customerId: '3',
        date: createDate(-1.9).toISOString(),
        isActive: true,
        alertType: AlertType.ELIGIBLE_PRODUCT
    },
    {
        id: `${alertID++}`,
        customerId: '4',
        date: createDate(-2).toISOString(),
        isActive: true,
        alertType: AlertType.LIMIT
    }
];
